import { InstagramLogo, WhatsappLogo, Sparkle } from "@phosphor-icons/react";
import { Logo } from "../Logo";
import { SITE, waLink } from "../../config/site";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer-section"
      className="relative bg-sand border-t border-line py-16"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-10">
          <div>
            <Logo tone="dark" />
            <p className="font-body text-slate/60 mt-5 italic">{SITE.tagline}</p>
          </div>

          <div className="flex items-center gap-4">
            <a
              href={SITE.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="flex items-center gap-2 rounded-full border border-line px-5 py-3 font-body text-sm text-slate hover:text-gold hover:border-gold/50 transition-all duration-300"
            >
              <InstagramLogo size={18} weight="light" />@{SITE.instagram}
            </a>
            <a
              href={waLink("Oi! Quero saber mais sobre a Templo Savassi.")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp"
              className="flex items-center gap-2 rounded-full border border-line px-5 py-3 font-body text-sm text-slate hover:text-gold hover:border-gold/50 transition-all duration-300"
            >
              <WhatsappLogo size={18} weight="light" />
              WhatsApp
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-line flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-body text-slate/50 text-sm">
            © {year} Templo Jiu-Jitsu Culture — Savassi.
          </p>
          <a
            href="https://forjadigital.tec.br"
            target="_blank"
            rel="noopener"
            data-testid="footer-forja-credit"
            className="group flex items-center gap-1.5 font-body text-xs text-slate/45 hover:text-[#ed7b3a] transition-colors duration-300"
          >
            <Sparkle size={14} weight="fill" className="text-[#ed7b3a]" />
            Feito por <span className="font-semibold">Forja Digital</span>
          </a>
        </div>
      </div>
    </footer>
  );
};
